import { useLocation } from 'react-router-dom';
import { BatchDetailsForm } from './BatchDetailsForm';
import { useCreateOrViewOrEditBatch } from './useCreateOrViewOrEditBatch';
import {
	Batch,
	LocationState,
} from '../../../../shared/VolunteerApplicationServiceTypes';
import { useEffect, useState } from 'react';
import { useBatchList } from '../useBatchList';

export const ScreeningCreateBatch = () => {
	const { batchData } = useBatchList();
	const {
		form,
		batch,
		onSubmitClick,
		onCancelClick,
		submitButtonDisabled,
		isEditFormStatus,
		onPublishBatchClick,
	} = useCreateOrViewOrEditBatch();
	const [viewBatchForm, setViewBatchForm] = useState<boolean>(false);
	const location = useLocation();
	const state = location.state as LocationState | null;
	const { batches } = batchData;
	const activeBatches = batches.filter(
		(batchParam: Batch) => batchParam.status === 'ACTIVE'
	);
	const activeBatch = activeBatches[0];

	const viewBatchTest = state?.from;

	useEffect(() => {
		if (viewBatchTest === 'FROM_VIEW_BATCH') {
			setViewBatchForm(true);
		}
	}, [viewBatchTest]);

	return (
		<div className="flex flex-col px-[8px]">
			<BatchDetailsForm
				form={form}
				batch={batch}
				activeBatch={activeBatch}
				isEditForm={isEditFormStatus}
				onAddEditBatchSubmit={onSubmitClick}
				onPublishBatch={onPublishBatchClick}
				onCancelClick={onCancelClick}
				submitButtonDisabled={submitButtonDisabled}
				viewBatchForm={viewBatchForm}
			/>
		</div>
	);
};
